import React from "react";

/**
 * CLEANBAZ Logo — uses the official uploaded artwork.
 *  - `variant='full'` (default): full lock-up crop (roof + CLEANBAZ + CLEANING SERVICES + CLEAN. FRESH. DONE.™)
 *  - `variant='icon'`: house / sparkle / leaf icon only (no wordmark) — for the header
 *  - `variant='raw'`: untouched square upload including bottom service-icon row
 */
export default function CleanzaLogo({ height = 96, variant = "full", className = "" }) {
  const src =
    variant === "raw"  ? "/brand/cleanza-logo.png" :
    variant === "icon" ? "/brand/cleanza-icon.png" :
                         "/brand/cleanza-logo-mark.png";
  const isIcon = variant === "icon";
  return (
    <img
      src={src}
      alt="CLEANBAZ — Cleaning Services · Clean. Fresh. Done."
      style={{ height, width: "auto" }}
      className={`select-none ${isIcon ? "" : "rounded-2xl ring-1 ring-slate-900/10 shadow-[0_10px_30px_-12px_rgba(20,184,166,0.45)]"} ${className}`}
      draggable={false}
    />
  );
}
